import { createSlice } from "@reduxjs/toolkit";
import { fetchCompensationData, fetchHRwiseAttendanceDetails, fetchHRwiseWorkforceEmployees, fetchMonthlySummaryForWorkforce, fetchResignationData, fetchWorkforceData } from "./hrDashboardAction";
import { fetchAttendanceData } from "./hrDashboardAction";
import { HRDashboard } from "./hrDashboardTypes";

const initialState: HRDashboard = {
    workforceData: null,
    attendanceData: null,
    compensationData: null,
    monthwiseData: null,
    hrWiseResignation: null,
    hrEmployees: null,
    attendanceEmployees: null,
    loading: false,
    error: undefined,
};

export const hrDashboardSlice = createSlice({
    name: "hrDashboard",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchWorkforceData.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchWorkforceData.fulfilled, (state, action) => {
                state.loading = false;
                state.workforceData = action.payload.data;
            })
            .addCase(fetchWorkforceData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
        builder
            // Fetch Attendance
            .addCase(fetchAttendanceData.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchAttendanceData.fulfilled, (state, action) => {
                state.loading = false;
                state.attendanceData = action.payload.data;
            })
            .addCase(fetchAttendanceData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
        builder
            //Fetch Compensation
            .addCase(fetchCompensationData.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchCompensationData.fulfilled, (state, action) => {
                state.loading = false;
                state.compensationData = action.payload.data;
            })
            .addCase(fetchCompensationData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
        builder
            //fetch filter month and year wise data
            .addCase(fetchMonthlySummaryForWorkforce.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchMonthlySummaryForWorkforce.fulfilled, (state, action) => {
                state.loading = false;
                state.monthwiseData = action.payload.data;
            })
            .addCase(fetchMonthlySummaryForWorkforce.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
        builder
            //fetch resignation data
            .addCase(fetchResignationData.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchResignationData.fulfilled, (state, action) => {
                state.loading = false;
                state.hrWiseResignation = action.payload.data;
            })
            .addCase(fetchResignationData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(fetchHRwiseWorkforceEmployees.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchHRwiseWorkforceEmployees.fulfilled, (state, action) => {
                state.loading = false;
                state.hrEmployees = action.payload.data; 
            })
            .addCase(fetchHRwiseWorkforceEmployees.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(fetchHRwiseAttendanceDetails.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchHRwiseAttendanceDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.attendanceEmployees = action.payload.data; 
            })
            .addCase(fetchHRwiseAttendanceDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
    }
});

export default hrDashboardSlice.reducer;